import React, { Component } from 'react';

class Rules extends Component {
    componentDidMount() {
        document.title = "Addiction | Rules"
    }

    render() {
        return (

            <div>
                <div className="panel-adt">
                    <h2>Website and Forum Policies</h2>
                    <p>Basic site conduct to be followed at all times:</p>
                    <ul>
                        <li>Only one account per person is allowed.</li>
                        <li>All communication must be made in English or it will be deleted.</li>
                        <li>No unwarranted attacking of non-member users.</li>
                        <li>No topic necroing. (Revival of dead topics because you are too clued out to read a date).
                        </li>
                        <li>Read stickies before posting to avoid double posting material or asking pointless questions
                            that have already been answered.
                        </li>
                        <li>Do not double post within a topic. You have the ability to edit your post and should do
                            so.
                        </li>
                        <li>Continual full-capslock posting will not be tolerated.</li>
                        <li>Refrain from posting topics in the wrong forums.</li>
                        <li>Do not post controversial imagery on any public section of the website.</li>
                    </ul>
                    <p>Failure to follow these basic guidelines or to act with common sense will result in forum
                        account deactivation and/or further action.
                    </p>
                </div>
                <div className="panel-adt">
                    <h2>Social Expectations</h2>
                    <p>We at Addiction abhor drama and have a strict no-drama policy. Instigating anything that is
                        remotely considered drama will not be tolerated.</p>
                    <p>We expect all of our members to follow common social conventions, but as this subject is filled
                        with grey areas you are expected to use your better judgement in related situations.</p>
                    <p>Disputes or problems with other members or the guild itself must be dealt with through private
                        channels only. Public rant posts will not be tolerated. You are entitled to express yourself,
                        but must do so to the right people.</p>
                    <p>Bickering between members is not tolerated and it will be the problem instigator who will be
                        dealt with accordingly.</p>
                    <p>You are expected to uphold a reasonable level of respect towards your guild mates at all times.
                        They are, after all, the ones who have your back.</p>
                    <p>Avoid conversations about Religion, Racism, or Politics in public channels as one never knows who
                        is listening, and what their personal views might be.</p>
                    <p>We enjoy a mature atmosphere in Addiction, but if someone is offended by something you are
                        doing/saying and asks you to stop you are expected to stop immediately. As we are a
                        multi-national guild with people from many walks of life it is very likely you will encounter a
                        guild mate who says something that you find offensive. We strongly encourage our members to try
                        to be understanding, or 'roll with the punches' so to speak, as everyone is entitled to their
                        own opinions.</p>
                </div>
                <div className="panel-adt">
                    <h2>Guild Removal</h2>

                    <p>The following are some blatant reasons for immediate removal:</p>
                    <ul>
                        <li>1 week absence without notice. Logging in for 10 minutes every few days won't save you.</li>
                        <li>Challenging, disobeying, disrespecting or refusing to comply with an Addiction officer. This
                            undermines authority and here at Addiction we stand by our officers.
                        </li>
                        <li>Any form of usage of 3rd party software or anything that breaks or automates game mechanics.
                            This includes posting exploits.
                        </li>
                        <li>Incompetence.</li>
                        <li>Leaving a raid without explicit permissions from a raid leader. Raid leaders will never
                            attempt to hold you on a raid if a real life situation does not permit you to continue.
                        </li>
                        <li>Any form of exploitation, hacking, or purposeful 'breaking' of the Addiction website or
                            systems.
                        </li>
                        <li>Public calling out, or 'attacking', of specific guild members or the guild itself. Problems
                            are to be resolved through the appropriate channels.
                        </li>
                        <li>Sharing guild information or strategies with other guilds without explicit consent from the
                            leadership.
                        </li>
                        <li>Our rules do not attempt to be completely thorough, but rather a guideline. Any gray areas
                            are expected to be handled with common sense, and will be decided upon by the leadership of
                            the Guild.
                        </li>
                    </ul>
                </div>
                <div className="panel-adt">
                    <h2>Raid Attendance</h2>
                    <p>We expect every member to maintain a raid attendance >60%. Attendance is rewarded to all members
                        ready to raid at 6PM PST/9PM EST even if you are asked to sit out on the raid. Partial
                        attendance will be awarded for those leaving early or arriving late.</p>

                    <h4>Example</h4>
                    <p>For each raid you show up on time and stay for the entire raid or you are asked to sit out on the
                        raid you earn an attendance of 1. For each raid you show up late or leave early you earn an
                        attendance of 0.6.</p>
                    <p>A member misses one raid, shows up late to another and stays for 5 entire raids
                        (5.6/7*100=80%).</p>
                </div>
                <div className="panel-adt">
                    <h2>Earning DKP</h2>
                    <p>DKP is awarded for each hour you spend on a raid as well as for each boss mob kill. The amount of
                        DKP awarded will be higher for new content areas than areas that are on farm status.</p>
                    <h4>Example</h4>
                    <p>New content earns 3DKP per hour and 3DKP per boss kill.</p>
                    <p>Farm status content is content we have easily killed a few times without raid wiping. This
                        content earns 2DKP per hour and 2DKP per boss kill.</p>
                    <p>If you believe there is an error in your DKP total please contact an officer.</p>
                </div>
                <div className="panel-adt">
                    <h2>Spending DKP</h2>
                    <p>Bidding will take place after each encounter when items drop. You may not bid on items for the
                        purpose of selling or for items not intended for your class.</p>
                    <p>Bidding begins at the items minimal value and is bid up quickly in 5 DKP increments. You may not
                        bid higher than your current DKP total. There is no ceiling to how much DKP an item can go for
                        and therefore bidding will continue until no bid is received for 10 seconds. Bidding will occur
                        in raid chat.</p>

                    <h4>Example</h4>
                    <p>New content item minimum is 15DKP and farm status content item minimum is 10DKP.</p>
                    <p>Items necessary for main tanking will be awarded to the guild's main tank at the item's minimal
                        value. This only occurs when the item is of a significant upgrade. We feel the tank's gear is
                        most critical to our raid success.</p>

                    <p>Items that are not awarded to a player will be placed in the guild bank if tradable and otherwise
                        sold for guild funds.</p>
                </div>
            </div>
        )
    }
}


export default Rules;


// WEBPACK FOOTER //
// ./src/About/Rules.js